import cx from 'classnames';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {hideLoginModal, userLoggedIn} from '~/common/fabric/Card/components/LoginModal/reducer';
import {useCurrentRoute} from '~/QuickEcards/hooks/useCurrentRoute';
import {useAppSelector} from '~/QuickEcards/store';
import {LoginWrapper} from '~library/organisms/LoginModal/LoginWrapper';

export const LoginModalReduxWrapper = () => {
  const dispatch = useDispatch();
  const {currentRoute} = useCurrentRoute();
  const showModal = useAppSelector((state) => state.loginModal.showLoginModal);

  const handleAuthSuccess = useCallback(
    (
      userId: string,
      fullName: string,
      subscriptionPlanName: string,
      email: string,
      avatarDisk: string,
      imgUrl: string,
      initials: string,
      firstName: string
    ) =>
      dispatch(
        userLoggedIn(
          userId,
          fullName,
          subscriptionPlanName,
          email,
          avatarDisk,
          imgUrl,
          initials,
          firstName
        )
      ),
    [dispatch]
  );

  if (currentRoute?.path !== 'create') return null;
  return (
    <>
      <div
        className={
          !showModal ? 'login-modal-background bg-hidden' : 'login-modal-background bg-visible'
        }
      />
      <div className={cx('meganav-auth-slideout', {open: showModal})}>
        <LoginWrapper
          onSignupSuccess={handleAuthSuccess}
          onLoginSuccess={handleAuthSuccess}
          onCloser={() => dispatch(hideLoginModal())}
        />
      </div>
    </>
  );
};
